(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4747],{

/***/ 7676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ ScrollView; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59740);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_native_web_dist_exports_ScrollView__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93133);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82075);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41580);
/* harmony import */ var _utils_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69232);
/* harmony import */ var _hooks_useHasResponsiveProps__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87166);
var _excluded=["_contentContainerStyle","contentContainerStyle"];function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}var StyledScrollView=(0,_utils_styled__WEBPACK_IMPORTED_MODULE_1__/* .makeStyledComponent */ .R)(react_native_web_dist_exports_ScrollView__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);var ScrollView=(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(props,ref){var _usePropsResolution=(0,_hooks__WEBPACK_IMPORTED_MODULE_3__/* .usePropsResolution */ .n)("ScrollView",props,{}),_contentContainerStyle=_usePropsResolution._contentContainerStyle,contentContainerStyle=_usePropsResolution.contentContainerStyle,resolvedProps=(0,_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_usePropsResolution,_excluded);var resolved_ContentContainerStyle=(0,_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useStyledSystemPropsResolver */ .t)(_contentContainerStyle||{});if((0,_hooks_useHasResponsiveProps__WEBPACK_IMPORTED_MODULE_6__/* .useHasResponsiveProps */ .M)(props)){return null;}return react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledScrollView,_extends({},resolvedProps,{contentContainerStyle:contentContainerStyle||resolved_ContentContainerStyle,ref:ref}));});

/***/ }),

/***/ 39388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ primitives_Button_Button; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(56666);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/primitives/Spinner/index.js
var Spinner = __webpack_require__(57787);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/hooks/useThemeProps/usePropsResolution.js + 4 modules
var usePropsResolution = __webpack_require__(82075);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/primitives/Box/index.js + 2 modules
var Box = __webpack_require__(4934);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/primitives/Stack/HStack.js
var HStack = __webpack_require__(79305);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/primitives/Pressable/Pressable.js
var Pressable = __webpack_require__(5621);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/utils/mergeRefs.js
var mergeRefs = __webpack_require__(42568);
// EXTERNAL MODULE: ../../node_modules/@react-native-aria/focus/lib/module/index.web.js + 1 modules
var index_web = __webpack_require__(11247);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/hooks/useHasResponsiveProps.js
var useHasResponsiveProps = __webpack_require__(87166);
;// CONCATENATED MODULE: ../../node_modules/native-base/lib/module/components/primitives/Button/Button.js
var _excluded=["children","startIcon","rightIcon","leftIcon","endIcon","spinner","isDisabled","isLoading","isHovered","isPressed","isFocused","isFocusVisible","spinnerPlacement"],_excluded2=["onPressIn","onPressOut","onHoverIn","onHoverOut","onFocus","onBlur","_text","_stack","_spinner","isLoadingText","_icon"];function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){(0,defineProperty/* default */.Z)(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}var Button=function Button(param,ref){var children=param.children,startIcon=param.startIcon,rightIcon=param.rightIcon,leftIcon=param.leftIcon,endIcon=param.endIcon,spinner=param.spinner,isDisabled=param.isDisabled,isLoading=param.isLoading,isHoveredProp=param.isHovered,isPressedProp=param.isPressed,isFocusedProp=param.isFocused,isFocusVisibleProp=param.isFocusVisible,_param$spinnerPlaceme=param.spinnerPlacement,spinnerPlacement=_param$spinnerPlaceme===void 0?"start":_param$spinnerPlaceme,props=(0,objectWithoutProperties/* default */.Z)(param,_excluded);var _props$accessibilityR;var _useHover=(0,Pressable/* useHover */.XI)(),hoverProps=_useHover.hoverProps,isHovered=_useHover.isHovered;var _useIsPressed=(0,Pressable/* useIsPressed */.VU)(),pressableProps=_useIsPressed.pressableProps,isPressed=_useIsPressed.isPressed;var _useFocus=(0,Pressable/* useFocus */.KK)(),focusProps=_useFocus.focusProps,isFocused=_useFocus.isFocused;var _useFocusRing=(0,index_web/* useFocusRing */.Fx)(),isFocusVisible=_useFocusRing.isFocusVisible,focusRingProps=_useFocusRing.focusProps;var _usePropsResolution=(0,usePropsResolution/* usePropsResolution */.n)("Button",props,{isDisabled:isDisabled,isHovered:isHoveredProp||isHovered,isFocused:isFocusedProp||isFocused,isPressed:isPressedProp||isPressed,isLoading:isLoading,isFocusVisible:isFocusVisibleProp||isFocusVisible}),onPressIn=_usePropsResolution.onPressIn,onPressOut=_usePropsResolution.onPressOut,onHoverIn=_usePropsResolution.onHoverIn,onHoverOut=_usePropsResolution.onHoverOut,onFocus=_usePropsResolution.onFocus,onBlur=_usePropsResolution.onBlur,_text=_usePropsResolution._text,_stack=_usePropsResolution._stack,_spinner=_usePropsResolution._spinner,isLoadingText=_usePropsResolution.isLoadingText,_icon=_usePropsResolution._icon,resolvedProps=(0,objectWithoutProperties/* default */.Z)(_usePropsResolution,_excluded2);if((0,useHasResponsiveProps/* useHasResponsiveProps */.M)(props)){return null;}if(leftIcon){startIcon=leftIcon;}if(rightIcon){endIcon=rightIcon;}if(endIcon&&react.isValidElement(endIcon)){endIcon=react.Children.map(endIcon,function(child,index){return react.cloneElement(child,_objectSpread(_objectSpread({key:"button-end-icon-".concat(index)},_icon),child.props));});}if(startIcon&&react.isValidElement(startIcon)){startIcon=react.Children.map(startIcon,function(child,index){return react.cloneElement(child,_objectSpread(_objectSpread({key:"button-start-icon-".concat(index)},_icon),child.props));});}var spinnerElement=spinner?spinner:react.createElement(Spinner/* default */.Z,_extends({color:_text===null||_text===void 0?void 0:_text.color},_spinner));var boxChildren=function boxChildren(child){return child?react.createElement(Box/* default */.Z,{_text:_text},child):null;};return react.createElement(Pressable/* default */.ZP,_extends({disabled:isDisabled||isLoading,ref:ref,onPressIn:(0,mergeRefs/* composeEventHandlers */.M)(onPressIn,pressableProps.onPressIn),onPressOut:(0,mergeRefs/* composeEventHandlers */.M)(onPressOut,pressableProps.onPressOut),onHoverIn:(0,mergeRefs/* composeEventHandlers */.M)(onHoverIn,hoverProps.onHoverIn),onHoverOut:(0,mergeRefs/* composeEventHandlers */.M)(onHoverOut,hoverProps.onHoverOut),onFocus:(0,mergeRefs/* composeEventHandlers */.M)((0,mergeRefs/* composeEventHandlers */.M)(onFocus,focusProps.onFocus),focusRingProps.onFocus),onBlur:(0,mergeRefs/* composeEventHandlers */.M)((0,mergeRefs/* composeEventHandlers */.M)(onBlur,focusProps.onBlur),focusRingProps.onBlur)},resolvedProps,{accessibilityRole:(_props$accessibilityR=props.accessibilityRole)!==null&&_props$accessibilityR!==void 0?_props$accessibilityR:"button"}),react.createElement(HStack/* default */.Z,_extends({},_stack,{test:true}),startIcon&&!isLoading?startIcon:null,isLoading&&spinnerPlacement==="start"?spinnerElement:null,isLoading?isLoadingText?boxChildren(isLoadingText):null:boxChildren(children),endIcon&&!isLoading?endIcon:null,isLoading&&spinnerPlacement==="end"?spinnerElement:null));};/* harmony default export */ var Button_Button = ((0,react.memo)((0,react.forwardRef)(Button)));
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/primitives/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(76308);
;// CONCATENATED MODULE: ../../node_modules/native-base/lib/module/components/primitives/Button/ButtonGroup.js
var ButtonGroup_excluded=["children","divider","variant"],ButtonGroup_excluded2=["space","direction","size","colorScheme","isDisabled","isAttached"];function ButtonGroup_ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function ButtonGroup_objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ButtonGroup_ownKeys(Object(source),!0).forEach(function(key){(0,defineProperty/* default */.Z)(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ButtonGroup_ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function ButtonGroup_extends(){ButtonGroup_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return ButtonGroup_extends.apply(this,arguments);}/* harmony default export */ var ButtonGroup = ((0,react.memo)((0,react.forwardRef)(function(param,ref){var children=param.children,divider=param.divider,variant=param.variant,props=(0,objectWithoutProperties/* default */.Z)(param,ButtonGroup_excluded);var _usePropsResolution=(0,usePropsResolution/* usePropsResolution */.n)("ButtonGroup",props),space=_usePropsResolution.space,direction=_usePropsResolution.direction,size=_usePropsResolution.size,colorScheme=_usePropsResolution.colorScheme,isDisabled=_usePropsResolution.isDisabled,isAttached=_usePropsResolution.isAttached,newProps=(0,objectWithoutProperties/* default */.Z)(_usePropsResolution,ButtonGroup_excluded2);var _usePropsResolution2=(0,usePropsResolution/* usePropsResolution */.n)("Button",props),borderRadius=_usePropsResolution2.borderRadius;var computedChildren;if(Array.isArray(children)){computedChildren=react.Children.toArray(children).map(function(child,index){if(typeof child==="string"||typeof child==="number")return child;return react.cloneElement(child,ButtonGroup_objectSpread(ButtonGroup_objectSpread(ButtonGroup_objectSpread(ButtonGroup_objectSpread(ButtonGroup_objectSpread({key:"button-group-child-".concat(index),variant:variant,size:size,colorScheme:colorScheme,isDisabled:isDisabled},isAttached?{borderRadius:0}:{}),isAttached&&index===0?direction==="column"?{borderTopRadius:borderRadius}:{borderLeftRadius:borderRadius}:{}),isAttached&&index===(children===null||children===void 0?void 0:children.length)-1?direction==="column"?{borderBottomRadius:borderRadius}:{borderRightRadius:borderRadius}:{}),isAttached&&index!==0?direction==="column"?{borderTopWidth:0}:{borderLeftWidth:0}:{}),child.props));});}else{computedChildren=react.Children.toArray(children).map(function(child,index){return react.cloneElement(child,ButtonGroup_objectSpread({key:"button-group-child-".concat(index),variant:variant,size:size,colorScheme:colorScheme,isDisabled:isDisabled},child.props));});}if((0,useHasResponsiveProps/* useHasResponsiveProps */.M)(props)){return null;}return react.createElement(Stack/* default */.Z,ButtonGroup_extends({divider:divider,space:isAttached?0:space,direction:direction},newProps,{ref:ref}),computedChildren);})));
;// CONCATENATED MODULE: ../../node_modules/native-base/lib/module/components/primitives/Button/index.js
var ButtonTemp=Button_Button;ButtonTemp.Group=ButtonGroup;var primitives_Button_Button=ButtonTemp;

/***/ }),

/***/ 57787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59740);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_native_web_dist_exports_ActivityIndicator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67196);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82075);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41580);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2626);
/* harmony import */ var _hooks_useHasResponsiveProps__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87166);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80233);
var _excluded=["color","size","style","testID"];var Spinner=function Spinner(props,ref){var _usePropsResolution=(0,_hooks__WEBPACK_IMPORTED_MODULE_1__/* .usePropsResolution */ .n)("Spinner",props),color=_usePropsResolution.color,size=_usePropsResolution.size,style=_usePropsResolution.style,testID=_usePropsResolution.testID,resolvedProps=(0,_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_usePropsResolution,_excluded);var resolvedColor=(0,_theme__WEBPACK_IMPORTED_MODULE_3__/* .getColor */ .Lq)(color,(0,_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useTheme */ .F)().colors,(0,_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useTheme */ .F)());var resolvedStyle=(0,_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useStyledSystemPropsResolver */ .t)(resolvedProps);if((0,_hooks_useHasResponsiveProps__WEBPACK_IMPORTED_MODULE_6__/* .useHasResponsiveProps */ .M)(props)){return null;}return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_native_web_dist_exports_ActivityIndicator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,{testID:testID,accessible:true,accessibilityLabel:"loading",color:resolvedColor,ref:ref,size:size,style:[resolvedStyle,style]});};/* harmony default export */ __webpack_exports__["Z"] = ((0,react__WEBPACK_IMPORTED_MODULE_0__.memo)((0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Spinner)));

/***/ }),

/***/ 7379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useBreakpointValue; }
/* harmony export */ });
/* harmony import */ var react_native_web_dist_exports_useWindowDimensions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55523);
/* harmony import */ var _theme_tools__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17378);
/* harmony import */ var _hooks_useTheme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80233);
function useBreakpointValue(values){var _useWindowDimensions;var windowWidth=(_useWindowDimensions=(0,react_native_web_dist_exports_useWindowDimensions__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)())===null||_useWindowDimensions===void 0?void 0:_useWindowDimensions.width;var theme=(0,_hooks_useTheme__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .F)();if((0,_theme_tools__WEBPACK_IMPORTED_MODULE_2__/* .hasValidBreakpointFormat */ .b$)(values,theme.breakpoints)){var currentBreakpoint=(0,_theme_tools__WEBPACK_IMPORTED_MODULE_2__/* .getClosestBreakpoint */ .Zn)(theme.breakpoints,windowWidth);return (0,_theme_tools__WEBPACK_IMPORTED_MODULE_2__/* .findLastValidBreakpoint */ .CQ)(values,theme.breakpoints,currentBreakpoint);}else{return values;}}

/***/ }),

/***/ 67196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7896);
/* harmony import */ var _babel_runtime_helpers_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31461);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _StyleSheet__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82399);
/* harmony import */ var _View__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62934);
var _excluded=["animating","color","hidesWhenStopped","size","style"];var createSvgCircle=function createSvgCircle(style){return react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle",{cx:"16",cy:"16",fill:"none",r:"14",strokeWidth:"4",style:style});};var ActivityIndicator=react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function(props,forwardedRef){var _props$animating=props.animating,animating=_props$animating===void 0?true:_props$animating,_props$color=props.color,color=_props$color===void 0?"#1976D2":_props$color,_props$hidesWhenStopp=props.hidesWhenStopped,hidesWhenStopped=_props$hidesWhenStopp===void 0?true:_props$hidesWhenStopp,_props$size=props.size,size=_props$size===void 0?"small":_props$size,style=props.style,other=(0,_babel_runtime_helpers_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props,_excluded);var svg=react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",{height:"100%",viewBox:"0 0 32 32",width:"100%"},createSvgCircle({stroke:color,opacity:0.2}),createSvgCircle({stroke:color,strokeDasharray:80,strokeDashoffset:60}));return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_View__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,(0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({},other,{accessibilityRole:"progressbar",accessibilityValueMax:1,accessibilityValueMin:0,ref:forwardedRef,style:[styles.container,style]}),react__WEBPACK_IMPORTED_MODULE_0__.createElement(_View__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,{children:svg,style:[typeof size==="number"?{height:size,width:size}:indicatorSizes[size],styles.animation,!animating&&styles.animationPause,!animating&&hidesWhenStopped&&styles.hidesWhenStopped]}));});ActivityIndicator.displayName="ActivityIndicator";var styles=_StyleSheet__WEBPACK_IMPORTED_MODULE_4__/* ["default"].create */ .Z.create({container:{alignItems:"center",justifyContent:"center"},hidesWhenStopped:{visibility:"hidden"},animation:{animationDuration:"0.75s",animationKeyframes:[{"0%":{transform:[{rotate:"0deg"}]},"100%":{transform:[{rotate:"360deg"}]}}],animationTimingFunction:"linear",animationIterationCount:"infinite"},animationPause:{animationPlayState:"paused"}});var indicatorSizes=_StyleSheet__WEBPACK_IMPORTED_MODULE_4__/* ["default"].create */ .Z.create({small:{width:20,height:20},large:{width:36,height:36}});/* harmony default export */ __webpack_exports__["Z"] = (ActivityIndicator);

/***/ }),

/***/ 72448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29798);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
"use client";



/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-2h2zm0-4h-2V7h2z"
}), 'Error'));

/***/ }),

/***/ 56278:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/premium-1on1-consulting-service",
      function () {
        return __webpack_require__(48172);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 11151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/1on1_mobile_img_sub_01.9255b908.svg","height":350,"width":375});

/***/ }),

/***/ 82270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/1on1_pc_img_sub_01.cbb49496.svg","height":350,"width":920});

/***/ }),

/***/ 48172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ premium_1on1_consulting_service; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/primitives/Box/index.js + 2 modules
var Box = __webpack_require__(4934);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/basic/ScrollView/ScrollView.js
var ScrollView = __webpack_require__(7676);
// EXTERNAL MODULE: ../../packages/app/features/main/components/Header.tsx
var Header = __webpack_require__(90208);
// EXTERNAL MODULE: ./src/components/main/sections/Footer.tsx + 3 modules
var Footer = __webpack_require__(29049);
// EXTERNAL MODULE: ../../packages/app/colors/index.tsx
var colors = __webpack_require__(8521);
// EXTERNAL MODULE: ../../packages/app/features/component/svg.tsx
var svg = __webpack_require__(60092);
// EXTERNAL MODULE: ../../packages/app/hooks/useCommonResponsiveValues.ts
var useCommonResponsiveValues = __webpack_require__(89688);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/hooks/useBreakpointValue.js
var useBreakpointValue = __webpack_require__(7379);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/primitives/Stack/VStack.js
var VStack = __webpack_require__(67974);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/primitives/Text/index.js
var Text = __webpack_require__(80775);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/primitives/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(76308);
;// CONCATENATED MODULE: ../../packages/app/features/main/sub-page/components/premium-1on1-consulting-service/IntroSection1.tsx





const IntroSection1 = (param)=>{
    let { heroRef  } = param;
    const { containerWidth  } = (0,useCommonResponsiveValues/* default */.Z)();
    const textSizeProp = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: {
            size: "h6/600"
        },
        lg: {
            fontSize: "36px",
            fontWeight: 600,
            lineHeight: "60px"
        }
    });
    const imgSrc = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: {
            asset: __webpack_require__(11151),
            src: "/main/1on1_mobile_img_sub_01.svg"
        },
        lg: {
            asset: __webpack_require__(82270),
            src: "/main/1on1_pc_img_sub_01.svg"
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        bgColor: "singletons.black",
        alignItems: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VStack/* default */.Z, {
            ref: heroRef,
            w: "100%",
            py: {
                base: "72px",
                lg: "120px"
            },
            justifyContent: "center",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    h: "58px"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    size: (0,useBreakpointValue/* useBreakpointValue */.S)({
                        base: "h3/800",
                        lg: "h2/900/main"
                    }),
                    textAlign: "center",
                    color: colors/* default.white50 */.Z.white50,
                    children: "1:1 공부 컨설팅"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    mt: "24px",
                    ...textSizeProp,
                    textAlign: "center",
                    color: "singletons.white",
                    children: [
                        "대치동 아이들이 받는 ",
                        containerWidth.endsWith("%") && "\n",
                        "공부 컨설팅 그대로!",
                        "\n",
                        "종합학습진단 결과에 따라 검증된",
                        " ",
                        containerWidth.endsWith("%") && "\n",
                        "공부 컨설턴트가 아이를 구체적으로",
                        "\n",
                        "분석하여 목표대학을 향해",
                        " ",
                        containerWidth.endsWith("%") && "\n",
                        "공부할 수 있도록 컨설팅을 해드립니다.",
                        "\n"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    mt: {
                        base: "0px",
                        lg: "68px"
                    },
                    height: {
                        base: "300px",
                        lg: "250px"
                    },
                    alignItems: "center",
                    zIndex: 10,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* default */.Z, {
                        width: {
                            base: "375px",
                            lg: "920px"
                        },
                        height: {
                            base: "350px",
                            lg: "350px"
                        },
                        src: imgSrc.src,
                        asset: imgSrc.asset
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    zIndex: 1,
                    position: "absolute",
                    top: {
                        base: "580px",
                        lg: "630px"
                    },
                    width: {
                        base: "400px",
                        lg: "936px"
                    },
                    height: {
                        base: "400px",
                        lg: "936px"
                    },
                    borderRadius: {
                        base: "200px",
                        lg: "468px"
                    },
                    bgColor: colors/* default.green500 */.Z.green500
                })
            ]
        })
    });
};
/* harmony default export */ var premium_1on1_consulting_service_IntroSection1 = (IntroSection1);

;// CONCATENATED MODULE: ../../packages/app/features/main/constant/font.ts
const BodyFontBase = {
    size: "p_s/600"
};
const BodyFontLarge = {
    fontSize: "24px",
    lineHeight: "40px",
    fontWeight: 500
};

// EXTERNAL MODULE: ../../packages/app/features/special-lecture/special-lecture-player/video-list.ts
var video_list = __webpack_require__(40893);
;// CONCATENATED MODULE: ../../packages/app/features/main/sub-page/components/premium-1on1-consulting-service/IntroSection3.tsx






const IntroSection3 = ()=>{
    const { containerWidth  } = (0,useCommonResponsiveValues/* default */.Z)();
    const paddingY = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: "48px",
        lg: "120px"
    });
    const textSize2Props = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: "h3/800",
        lg: "h2/900/main"
    });
    const textSize3Props = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: BodyFontBase,
        lg: BodyFontLarge
    });
    const textSize4 = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: "p_m/700",
        lg: "h5/800"
    });
    const textSize5 = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: "p_m/700",
        lg: "h5/700"
    });
    const flexDirection = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: "column",
        xl: "row"
    });
    const textBoxSize = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: {
            width: "344px",
            height: "165px"
        },
        lg: {
            width: "413px",
            height: "324px"
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        bgColor: "singletons.white",
        alignItems: "center",
        py: paddingY,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VStack/* default */.Z, {
            w: containerWidth,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "singletons.black",
                    size: textSize2Props,
                    textAlign: "center",
                    children: "1:1 공부 컨설팅 영상"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    h: {
                        base: "24px",
                        lg: "32px"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    color: "gray.700",
                    ...textSize3Props,
                    textAlign: "center",
                    children: [
                        "수백만원 대치동 공부 컨설팅 효과 그대로!",
                        "\n",
                        "진단 결과를 바탕으로 현재를 점검하고,",
                        " ",
                        containerWidth.endsWith("%") && "\n",
                        "내신관리와 대입 로드맵 설계에 있어",
                        "\n",
                        "체계적인 개인별 맞춤 학습법을 제시합니다."
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    h: {
                        base: "24px",
                        lg: "60px"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    w: containerWidth,
                    alignItems: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        borderRadius: "20px",
                        maxW: "1280px",
                        width: {
                            base: "343px",
                            lg: "100%"
                        },
                        height: {
                            base: "193px",
                            lg: "720px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                            controls: true,
                            style: {
                                maxHeight: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                    base: "193px",
                                    lg: "720px"
                                })
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                src: "".concat(video_list/* baseVideoURL */.GN, "premium-1on1.mp4"),
                                type: "video/mp4"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    h: {
                        base: "24px",
                        lg: "60px"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    flexDirection: flexDirection,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(VStack/* default */.Z, {
                            px: {
                                base: "20px",
                                lg: "24px"
                            },
                            py: {
                                base: "24px",
                                lg: "32px"
                            },
                            w: textBoxSize.width,
                            h: textBoxSize.height,
                            bgColor: colors/* default.grey900 */.Z.grey900,
                            borderRadius: "16px",
                            space: "16px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: "gray.600",
                                    size: textSize4,
                                    children: "01"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: "singletons.white",
                                    size: textSize5,
                                    children: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                        base: "현재 대치동 학생들이 받고 있는\n실제 공부 컨설팅을 그대로 진행합니다.",
                                        lg: "현재 대치동 학생들이 받고 있는\n실제 공부 컨설팅을\n그대로 진행합니다."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            w: {
                                base: "16px",
                                lg: "20px"
                            },
                            h: {
                                base: "16px",
                                lg: "20px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(VStack/* default */.Z, {
                            px: {
                                base: "20px",
                                lg: "24px"
                            },
                            py: {
                                base: "24px",
                                lg: "32px"
                            },
                            w: textBoxSize.width,
                            h: textBoxSize.height,
                            bgColor: colors/* default.grey900 */.Z.grey900,
                            borderRadius: "16px",
                            space: "16px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: "gray.600",
                                    size: textSize4,
                                    children: "02"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: "singletons.white",
                                    size: textSize5,
                                    children: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                        base: "학부모님과 자녀가 대립할 필요 없이, \n공부 컨설턴트가 동기부여를 통해\n아이에게 공부의 필요성을 깨우쳐 줍니다.",
                                        lg: "학부모님과 자녀가 대립할 필요 없이, \n전문 컨설턴트가 동기부여를 통해\n아이에게 공부의 필요성을\n깨우쳐 줍니다."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            w: {
                                base: "16px",
                                lg: "20px"
                            },
                            h: {
                                base: "16px",
                                lg: "20px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(VStack/* default */.Z, {
                            px: {
                                base: "20px",
                                lg: "24px"
                            },
                            py: {
                                base: "24px",
                                lg: "32px"
                            },
                            w: textBoxSize.width,
                            h: {
                                base: "257px",
                                lg: "324px"
                            },
                            bgColor: colors/* default.grey900 */.Z.grey900,
                            borderRadius: "16px",
                            space: "16px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: "gray.600",
                                    size: textSize4,
                                    children: "03"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: "singletons.white",
                                    size: textSize5,
                                    children: (0,useBreakpointValue/* useBreakpointValue */.S)({
                                        base: "자녀 공부에 대한 모든 것에 대해\n명쾌한 해답을 내려드립니다.",
                                        lg: "자녀 공부에 대한 모든 것에 대해\n명쾌한 해답을 내려드립니다."
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    size: "p_s/500",
                                    color: colors/* default.grey400 */.Z.grey400,
                                    children: [
                                        "•",
                                        " 미래 성적과 대학 예측",
                                        "\n",
                                        "•",
                                        " 내 성향에 맞는 학원과 공부법",
                                        "\n",
                                        "•",
                                        " 이대로 하면 상위 1%! 과목별 공부법",
                                        "\n",
                                        "•",
                                        " 공부 다리 찢기 PLAN",
                                        "\n",
                                        "•",
                                        " 추천 학습법"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            w: {
                                base: "16px",
                                lg: "20px"
                            },
                            h: {
                                base: "16px",
                                lg: "20px"
                            }
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var premium_1on1_consulting_service_IntroSection3 = (IntroSection3);

// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/primitives/Button/index.js + 2 modules
var Button = __webpack_require__(39388);
// EXTERNAL MODULE: ../../node_modules/native-base/lib/module/components/primitives/Stack/HStack.js
var HStack = __webpack_require__(79305);
// EXTERNAL MODULE: ../../packages/app/features/main/hooks/useRoute.ts
var useRoute = __webpack_require__(80149);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/esm/Error.js
var Error = __webpack_require__(72448);
;// CONCATENATED MODULE: ../../packages/app/features/main/sub-page/components/premium-1on1-consulting-service/IntroSection5.tsx







const IntroSection5 = ()=>{
    const { containerWidth  } = (0,useCommonResponsiveValues/* default */.Z)();
    const { routePremiumConsultingFAQ  } = (0,useRoute/* default */.Z)();
    const textSize1 = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: "h3/800",
        lg: "h2/900/main"
    });
    const textSize2 = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: "p_s/600",
        lg: "h5/500/main"
    });
    const textSize4 = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: "h6/700",
        lg: "h5/700"
    });
    const textSize6 = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: "p_m/600",
        lg: "h6/600"
    });
    const textSize7 = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: "p_m/500",
        lg: "h6/500"
    });
    const buttonWidth = (0,useBreakpointValue/* useBreakpointValue */.S)({
        base: "343px",
        lg: "475px"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        py: {
            base: "60px",
            lg: "150px"
        },
        bgColor: {
            linearGradient: {
                colors: [
                    "#000000cc",
                    "#28303D"
                ],
                start: [
                    1,
                    0
                ],
                end: [
                    1,
                    1
                ]
            }
        },
        alignItems: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VStack/* default */.Z, {
            px: "16px",
            w: containerWidth,
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "singletons.white",
                    size: textSize1,
                    children: "FAQ"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    h: {
                        base: "24px",
                        lg: "32px"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "gray.400",
                    size: textSize2,
                    children: "1:1 공부 컨설팅에 대해 더 궁금한게 있으신가요?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    h: {
                        base: "24px",
                        lg: "32px"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    variant: "outline",
                    w: buttonWidth,
                    h: "60px",
                    _text: {
                        color: "singletons.white"
                    },
                    bgColor: colors/* default.transparent */.Z.transparent,
                    borderColor: "singletons.white",
                    _hover: {
                        bgColor: "#ffffff1f",
                        borderColor: "singletons.white"
                    },
                    _pressed: {
                        bgColor: "#ffffff1f",
                        borderColor: "singletons.white"
                    },
                    onPress: routePremiumConsultingFAQ,
                    children: "FAQ 바로가기"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    h: {
                        base: "40px",
                        lg: "60px"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(VStack/* default */.Z, {
                    px: {
                        base: "16px",
                        lg: "40px"
                    },
                    py: "40px",
                    w: "100%",
                    bgColor: "gray.800",
                    borderRadius: "20px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HStack/* default */.Z, {
                            alignItems: "center",
                            space: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Error/* default */.Z, {
                                    color: "primary"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    size: textSize4,
                                    color: "singletons.white",
                                    children: "상품 이용안내"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            h: {
                                base: "24px",
                                lg: "40px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VStack/* default */.Z, {
                            space: "40px",
                            children: ProductGuideList.map((item, index)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductGuideItem, {
                                    item: item,
                                    categoryTextSize: textSize6,
                                    guideTextSize: textSize7
                                }, index);
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var premium_1on1_consulting_service_IntroSection5 = (IntroSection5);
const ProductGuideList = [
    {
        category: "종합학습진단 관련",
        guide: [
            "1:1 공부 컨설팅은 진단 진행 후 1:1 라이브 컨설팅을 진행하는 상품입니다.",
            "1:1 공부컨설팅 상품을 구매할 경우, 종합학습진단은 무료로 제공됩니다.",
            "1:1 공부컨설팅을 구매하신 후, 종합학습진단을 실행하시면 진단을 무료로 받을 수 있습니다.",
            "종합학습진단을 구매하신 후 30일 이내에 1:1 공부컨설팅을 구매하신 회원 분께는 종합학습진단 비용을 환불처리 해드립니다."
        ]
    },
    {
        category: "1:1 공부컨설팅 관련",
        guide: [
            "1:1 공부컨설팅은 화상으로 진행되는 온라인 라이브 컨설팅입니다. 1:1 공부컨설팅은 예약된 스케줄 24시간이 도래하기 전에 변경할 수 있습니다.\n(예약 취소는 불가합니다.)",
            "예약된 스케줄이 24시간 미만으로 남은 경우 예약 스케줄을 변경할 수 없습니다.",
            "1:1 공부컨설팅은 학부모님과 학생이 모두 참여해주셔야 합니다.",
            "1:1 공부컨설팅 스케줄 예약은 구매 후 최대 1개월 내 진행되어야 합니다."
        ]
    },
    {
        category: "중단/환불 정책",
        guide: [
            "1:1 공부컨설팅 스케줄 예약 전일 경우, 서비스 이용대금 전액 환불해드립니다.",
            "1:1 공부컨설팅 스케줄이 예약된 경우, 공부 컨설턴트의 스케줄이 점유된 상태로 환불이 불가합니다."
        ]
    },
    {
        category: "결제 정책",
        guide: [
            "상품은 카드결제를 통해 결제 가능합니다.",
            "카드 할부 결제가 가능하며 무이자 할부 개월수는 각 카드사 및 결제 대행사(PG사) 할부 프로모션에 따라 상이합니다.",
            "무이자 카드 혜택은 카카오 상담톡 및 고객센터 페이지에서 확인 가능합니다."
        ]
    }
];
const ProductGuideItem = (param)=>{
    let { item , categoryTextSize , guideTextSize  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VStack/* default */.Z, {
            space: "16px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    size: categoryTextSize,
                    color: "singletons.white",
                    children: item.category
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(VStack/* default */.Z, {
                    children: item.guide.map((value, idx)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HStack/* default */.Z, {
                                space: "6px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "gray.400",
                                        size: guideTextSize,
                                        children: "•"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "gray.400",
                                        size: guideTextSize,
                                        children: value
                                    })
                                ]
                            })
                        }, idx);
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../packages/app/features/main/sub-page/premium-1on1-consulting-service/screen.tsx








const Screen = ()=>{
    const heroRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        backgroundColor: "singletons.white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                heroRef: heroRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                position: "absolute",
                h: "300px",
                top: "0",
                bgColor: "singletons.black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrollView/* ScrollView */.p, {
                bgColor: "singletons.black",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(premium_1on1_consulting_service_IntroSection1, {
                        heroRef: heroRef
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(premium_1on1_consulting_service_IntroSection3, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(premium_1on1_consulting_service_IntroSection5, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var screen = (Screen);

// EXTERNAL MODULE: ../../packages/core/constants/page-titles.ts
var page_titles = __webpack_require__(55931);
;// CONCATENATED MODULE: ./src/pages/premium-1on1-consulting-service/index.tsx







var ConsultingServicePage = function ConsultingServicePage() {
    return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (0,jsx_runtime.jsx)((head_default()), {
                children: (0,jsx_runtime.jsx)("title", {
                    children: page_titles/* URL_TITLE_MAP.ONE_ON_ONE_CONSULTING */.$.ONE_ON_ONE_CONSULTING
                })
            }),
            (0,jsx_runtime.jsx)(screen, {})
        ]
    });
};
/* harmony default export */ var premium_1on1_consulting_service = (ConsultingServicePage);


/***/ }),

/***/ 90208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _apps_next_src_components_main_sections_Header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87621);



const Header = (param)=>{
    let { heroRef , isStatic =false  } = param;
    const [isOverflowHeroImage, setIsOverflowHeroImage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isStatic || !(heroRef === null || heroRef === void 0 ? void 0 : heroRef.current)) return;
        const checkOverflowHeroImage = ()=>{
            var ref;
            const scrollY = window.scrollY;
            var ref1;
            const heroY = (ref1 = (ref = heroRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight) !== null && ref1 !== void 0 ? ref1 : 0;
            const isOverflowHeroImage = scrollY > heroY;
            setIsOverflowHeroImage(isOverflowHeroImage);
        };
        checkOverflowHeroImage();
        window.addEventListener("scroll", checkOverflowHeroImage);
        return ()=>{
            window.removeEventListener("scroll", checkOverflowHeroImage);
        };
    }, [
        heroRef,
        setIsOverflowHeroImage,
        isStatic
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_apps_next_src_components_main_sections_Header__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        isOverflowHeroImage: isOverflowHeroImage,
        headerBgColor: isOverflowHeroImage ? "bg-singletons-white" : "bg-singletons-black",
        titleTextColor: isOverflowHeroImage || isStatic ? "text-singletons-black" : "text-singletons-white"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Header);


/***/ }),

/***/ 40893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GN": function() { return /* binding */ baseVideoURL; },
/* harmony export */   "Uc": function() { return /* binding */ ParentVideoList; },
/* harmony export */   "nZ": function() { return /* binding */ StudentVideoList; },
/* harmony export */   "o2": function() { return /* binding */ baseMaterialURL; }
/* harmony export */ });
/* harmony import */ var app_common_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37326);

// 특강 자료 https://drive.google.com/drive/folders/19_yJLVD07T5K1tu-9UaYDUYlQ_m5CIEy
const baseVideoURL = app_common_constants__WEBPACK_IMPORTED_MODULE_0__/* .IS_DEV */ .TQ ? "https://bridge.knowre-dev.com/video/" : app_common_constants__WEBPACK_IMPORTED_MODULE_0__/* .IS_STG */ .YO ? "https://stg.briiidgeproject.com/video/" : app_common_constants__WEBPACK_IMPORTED_MODULE_0__/* .IS_STG2 */ .jf ? "https://stg2.briiidgeproject.com/video/" : app_common_constants__WEBPACK_IMPORTED_MODULE_0__/* .IS_PROD */ .XK ? "https://briiidgeproject.com/video/" : "https://bridge.knowre-dev.com/video/" // local
;
const baseMaterialURL = "/material/";
const StudentVideoList = [
    {
        title: "갓생사는 7가지 방법",
        description: "왜 공부를 해야하는지, 공부를 하면 무엇이 좋은 것인지 알려주는 강의입니다.",
        videoName: "student_lecture_001.mp4",
        playTime: "51:41",
        materialName: "s1.pdf",
        krMaterialName: "1강 갓생 사는 방법 7가지.pdf"
    },
    {
        title: "공부를 잘하고 싶으면 당연히 많이 해야 잘한다.",
        description: "공부를 잘하는 특별한 방법은 없다. 내가 가고 싶은 대학 몇시간 공부해야 할지 알려주는 강의입니다.",
        videoName: "student_lecture_002.mp4",
        playTime: "13:46",
        materialName: "s2.pdf",
        krMaterialName: "2강 공부를 잘하고 싶으면 당연히 많이 해야 잘한다.pdf"
    },
    {
        title: "학원은 원래 다니는 것이 아니다.",
        description: "학원은 원래 안 다니는 것이다. 학원 감별법을 알려주는 강의입니다.",
        videoName: "student_lecture_003.mp4",
        playTime: "53:40",
        materialName: "s3.pdf",
        krMaterialName: "3강 학원은 원래 다니는 것이 아니다.pdf"
    },
    {
        title: "시험공부는 평상시에 하는 것이다.",
        description: "내신 1등하는 방법은 아주 단순하다. 학원 다니지 않아도 1등하는 방법을 알려주는 강의입니다. ",
        videoName: "student_lecture_004.mp4",
        playTime: "41:18",
        materialName: "s4.pdf",
        krMaterialName: "4강 시험 공부는 평상시에 하는 것이다.pdf"
    },
    {
        title: "공부 방법도  MBTI에 맞춰야 잘할 수 있다.",
        description: "내 성격에 맞게 공부해야 힘든 공부도 조금 덜 힘들 수 있다. 내 성격에 맞는 공부 방법을 알려주는 강의입니다.",
        videoName: "student_lecture_005.mp4",
        playTime: "45:29",
        materialName: "s5.pdf",
        krMaterialName: "5강 공부방법도 MBTI에 맞춰야 잘할 수 있다.pdf"
    },
    {
        title: "학교 수업 직전/ 직후 3분은 게임케쉬다.",
        description: "수업 전후 3분은 시험기간 공부 3시간의 효과가 있다는 것을 알려주는 강의입니다.",
        videoName: "student_lecture_006.mp4",
        playTime: "14:02",
        materialName: "s6.pdf",
        krMaterialName: "6강 수업 직전, 직후 3분은 게임 캐시다.pdf"
    }
];
const ParentVideoList = [
    {
        title: "쉽고 빠른길은 어디에도 없습니다. 많이 시키십시오.",
        description: "광고에 끌려 다니지 마시고, 제대로 내 아이를 공부시키는 방법을 알려주는 강의입니다.",
        videoName: "parent_lecture_001.mp4",
        playTime: "15:51",
        materialName: "p1.pdf",
        krMaterialName: "1강_특별한 방법은 없습니다.그냥 많이 시키십시오.pdf"
    },
    {
        title: "공부 안하는 아이 공부 시키는 방법",
        description: "공부 시작이 어려운 아이를 어떻게 해야 공부를 하게 만드는지 알려주는 강의입니다.",
        videoName: "parent_lecture_002.mp4",
        playTime: "01:08:22",
        materialName: "p2.pdf",
        krMaterialName: "2강_공부 안하는 아이 공부시키는 방법.pdf"
    },
    {
        title: "1시간 만에 끝내는 대학 입시",
        description: "냉정한 현실 입시를 아셔야 아이를 잘 지도할 수 있습니다. 지금의 대입을 현실적으로 알려주는 강의입니다.",
        videoName: "parent_lecture_003.mp4",
        playTime: "47:34",
        materialName: "p3.pdf",
        krMaterialName: "3강_1시간 만에 끝내는 대학 입시.pdf"
    },
    {
        title: "EBS만 제대로 해도 SKY는 충분합니다.",
        description: "대치동과 같은 공부 효율을 낼 수 있는 EBS커리큘럼을 알려주는 강의입니다.",
        videoName: "parent_lecture_004.mp4",
        playTime: "30:11",
        materialName: "p4.pdf",
        krMaterialName: "4강_EBS만 제대로 해도 SKY진학 충분합니다.pdf"
    },
    {
        title: "이런 학원 절대 No! 내신학원 선택하는 방법",
        description: "고등학교에 들어가면 성적이 폭락하는 아이로 만들지 않기위한 제대로된 학원 선택 방법입니다.",
        videoName: "parent_lecture_005.mp4",
        playTime: "05:08",
        materialName: "p5.pdf",
        krMaterialName: "5강_내신학원의 필요성.pdf"
    },
    {
        title: "내신 시험 만점을 만드는 부모의 관리 방법",
        description: "학원에 보내도 성적이 오르지 않는 아이, 집에서 제대로 공부시키는 방법을 알려주는 강의입니다.",
        videoName: "parent_lecture_006.mp4",
        playTime: "45:35",
        materialName: "p6.pdf",
        krMaterialName: "6강_내신 시험 만점을 만드는 부모의 관리 방법.pdf"
    }
];


/***/ }),

/***/ 89688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var native_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7379);

const useCommonResponsiveValues = ()=>{
    const containerWidth = (0,native_base__WEBPACK_IMPORTED_MODULE_0__/* .useBreakpointValue */ .S)({
        base: "100%",
        lg: "992px",
        xl: "1280px"
    });
    return {
        containerWidth
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useCommonResponsiveValues);


/***/ }),

/***/ 55931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ URL_TITLE_MAP; }
/* harmony export */ });
/* harmony import */ var _is_hicampus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73018);

// https://docs.google.com/spreadsheets/d/1Z3LH-hzo37fGRMSkHrOTfBQC8lnt_N0b-3yizfSFx4I/edit#gid=0
// https://docs.google.com/spreadsheets/d/1UJe8BqquNyHfucJFz8hoEJ-zzOPeYOa8cSY2HYqj_q4/edit?gid=0#gid=0
const URL_TITLE_MAP = {
    // '/login'
    LOGIN: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 로그인" : "브릿지 프로젝트 - 로그인",
    // '/auth/agreement'
    AUTH_AGREEMENT: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜" : "브릿지 프로젝트",
    // '/comprehensive-learning-diagnosis/'
    COMPREHENSIVE_LEARNING_DIAGNOSTICS: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 종합학습진단" : "브릿지 프로젝트 - 종합학습진단",
    // '/premium-1on1-consulting-service/'
    ONE_ON_ONE_CONSULTING: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 1:1 공부 컨설팅" : "브릿지 프로젝트 - 1:1 공부 컨설팅",
    // '/all-care-pack/'
    ALL_CARE_PACK: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 1:1 All Care Pack" : "브릿지 프로젝트 - 1:1 All Care Pack",
    // '/pricing/'
    PRICING: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 상품안내" : "브릿지 프로젝트 - 상품안내",
    // '/promotion/whitepencil/'
    PROMOTION_WHITE_PENCIL: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 화이트 펜슬 제휴" : "브릿지 프로젝트 - 화이트 펜슬 제휴",
    // '/event/'
    EVENT: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 이벤트" : "브릿지 프로젝트 - 이벤트",
    // '/tab-bar/?path=home'
    HOME: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 학습홈" : "브릿지 프로젝트 - 학습홈",
    // '/tab-bar/?path=calendar'
    CALENDAR: "홈 - 공부 달력",
    // '/tab-bar/?path=report'
    REPORT: "홈 - 리포트",
    // '/tab-bar/?path=my-page'
    MY_PAGE: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 마이페이지" : "홈 - 마이페이지",
    // '/?path=diagnosticResult'
    HOME_DIAGNOSTIC_RESULT: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 학습 전략 진단 내역" : "홈 - 학습 전략 진단 내역",
    // '/?path=consulting'
    HOME_CONSULTING: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 컨설팅 내역" : "홈 - 컨설팅 내역",
    // '/calendar/study-plan/?date='
    CALENDAR_STUDY_PLAN: "공부 달력 - 공부 계획",
    // '/calendar/study-plan/guide'
    CALENDAR_STUDY_PLAN_GUIDE: "공부 달력 - 공부 계획 - 가이드",
    // '/calendar/study-plan-detail/?planId='
    STUDY_PLAN_DETAIL: "공부 달력 - 공부 계획 상세",
    // '/report/detail/daily/?id='
    REPORT_DAILY: "리포트 - 일간 리포트",
    // '/report/detail/weekly/?id='
    REPORT_WEEKLY: "리포트 - 주간 리포트",
    // '/diagnostic/diagnostic-list'
    DIAGNOSTIC_LIST: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 학습 전략 진단 내역" : "마이페이지 - 종합학습진단 내역",
    // '/diagnostic/test/?diagnosticSheetId='
    DIAGNOSTIC_TEST: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 학습 전략 진단 응시" : "종합학습진단 응시",
    // '/diagnostic/?resetDiagnosticSheetId='
    DIAGNOSTIC: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 학습 전략 진단 응시" : "종합학습진단 응시",
    // '/diagnostic/result/?diagnosticSheetId='
    DIAGNOSTIC_RESULT: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 학습 전략 진단 결과" : "종합학습진단 결과",
    // '/my-page/parent-connection/'
    MY_PAGE_PARENT_CONNECTION: "마이페이지 - 부모님 연결",
    // '/my-page/study-profile/?isStudent=true'
    MY_PAGE_STUDY_PROFILE: "마이페이지 - 공부현황 점검",
    // '/diagnostic/diagnostic-list/'
    MY_PAGE_DIAGNOSTICS: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 학습 전략 진단 내역" : "마이페이지 - 종합학습진단 내역",
    // '/consulting/reservation/book'
    CONSULTING_RESERVATION_BOOK: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 컨설팅 예약" : "마이페이지 - 컨설팅 예약",
    // '/consulting/reservations/'
    MY_PAGE_CONSULTING_RESERVATIONS: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 컨설팅 내역" : "마이페이지 - 컨설팅 내역",
    // '/consulting/reservations/change/?id='
    CONSULTING_CHANGE_RESERVATION: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 컨설팅 변경" : "마이페이지 - 컨설팅 변경",
    // '/consulting/reservations/detail/?id='
    MY_PAGE_CONSULTING_RESERVATIONS_DETAIL: _is_hicampus__WEBPACK_IMPORTED_MODULE_0__/* .isHicampus */ .e ? "하이캠퍼스 종합학습플랜 - 컨설팅 예약 상세" : "마이페이지 - 컨설팅 예약 상세",
    // '/special-lecture/'
    MY_PAGE_SPECIAL_LECTURE: "마이페이지 - 일깨움 특강",
    // '/my-page/setting/'
    MY_PAGE_SETTING: "마이페이지 - 설정",
    // '/billing/payment-history/'
    MY_PAGE_BILLING_PAYMENTS: "마이페이지 - 결제 내역",
    // '/billing/payment-details/?merchantUid'
    MY_PAGE_BILLING_PAYMENT_DETAILS: "결제 내역 - 결제 상세",
    // '/billing/manage-payment/'
    MY_PAGE_BILLING_MANAGE_PAYMENT: "마이페이지 - 결제 수단 관리",
    // '/billing/register-card/?beforeScreen=manage-payment&isChanged=false'
    MY_PAGE_BILLING_REGISTER_CARD: "결제 수단 관리 - 카드 등록",
    // '/my-page/register-coupon/'
    MY_PAGE_REGISTER_COUPON: "마이페이지 - 코드 등록",
    // '/my-page/inquiry/'
    MY_PAGE_INQUIRY: "마이페이지 - 1:1 문의",
    // '/my-page/request-inquiry/'
    MY_PAGE_REQUEST_INQUIRY: "1:1 문의 - 문의하기",
    // '/my-page/inquiry-detail/?inquiryId='
    MY_PAGE_INQUIRY_DETAIL: "1:1 문의 - 문의 내용"
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2038,4942,5621,4192,8686,9774,2888,179], function() { return __webpack_exec__(56278); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);